import DOMPurify from 'dompurify';

export const avisosApi = `${process.env.REACT_APP_API_URL}/api/Configuracoes/avisos`;
export const MAX_IMAGEM_AVISO = 5 * 1024 * 1024;
export const MAX_CONTEUDO_AVISO = 30000000;

export function sanitizarAviso(html = '') {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h1', 'h2', 'h3', 'ol', 'ul', 'li', 'blockquote', 'span', 'a', 'img'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'class'],
    ALLOW_DATA_ATTR: false,
  });
  const doc = new DOMParser().parseFromString(clean, 'text/html');
  doc.body.querySelectorAll('*').forEach(element => {
    Array.from(element.style).forEach(property => {
      if (!['color', 'background-color', 'text-align'].includes(property)) element.style.removeProperty(property);
    });
    [...element.classList].forEach(name => {
      if (!['ql-align-center', 'ql-align-right', 'ql-align-justify'].includes(name)) element.classList.remove(name);
    });
    if (element.tagName === 'A') {
      if (!/^(https?:\/\/|mailto:)/i.test(element.getAttribute('href') || '')) element.removeAttribute('href');
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener noreferrer');
    }
    if (element.tagName === 'IMG') {
      if (!/^(https:\/\/|data:image\/(png|jpeg|gif|webp);base64,)/i.test(element.getAttribute('src') || '')) element.remove();
      element.setAttribute('alt', element.getAttribute('alt') || 'Imagem do aviso');
    }
  });
  return doc.body.innerHTML;
}

export function temConteudoAviso(html) {
  const doc = new DOMParser().parseFromString(sanitizarAviso(html), 'text/html');
  return Boolean(doc.body.textContent.replace(/[\u200B\uFEFF]/g, '').trim() || doc.querySelector('img'));
}

export function dataParaCampo(value) {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

export function statusAviso(aviso, now = Date.now()) {
  if (!aviso.ativado) return { texto: 'Desativado', cor: 'secondary' };
  if (now < new Date(aviso.inicio).getTime()) return { texto: 'Agendado', cor: 'primary' };
  if (now >= new Date(aviso.fim).getTime()) return { texto: 'Encerrado', cor: 'secondary' };
  return { texto: 'Em exibição', cor: 'success' };
}

export function erroAviso(error) {
  const status = error.response?.status;
  if (status === 401) return 'Sua sessão não foi aceita. Entre novamente no portal.';
  if (status === 403) return 'Seu acesso não permite consultar ou alterar estes avisos (HTTP 403).';
  if (status === 404) return 'O serviço de avisos não foi encontrado. Verifique se a API está atualizada (HTTP 404).';
  if (status >= 500) return `O servidor falhou ao processar os avisos (HTTP ${status}). Tente novamente.`;
  if (error.request && !error.response) return 'Não foi possível conectar à API. Verifique se ela está em execução e tente novamente.';
  return error.response?.data?.message || 'Não foi possível concluir a operação. Tente novamente.';
}
